import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { getEntities as getTruckImplements } from 'app/entities/truck-implement/truck-implement.reducer';
import { ICompany } from 'app/shared/model/company.model';
import { getEntities as getCompanies } from 'app/entities/company/company.reducer';
import { IUser } from 'app/shared/model/user.model';
import { getUsers } from 'app/modules/administration/user-management/user-management.reducer';
import { getEntity, updateEntity, createEntity, reset } from './vehicle-position-last.reducer';
import { IVehiclePositionLast } from 'app/shared/model/vehicle-position-last.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const VehiclePositionLastUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const truckImplements = useAppSelector(state => state.truckImplement.entities);
  const companies = useAppSelector(state => state.company.entities);
  const users = useAppSelector(state => state.userManagement.users);
  const vehiclePositionLastEntity = useAppSelector(state => state.vehiclePositionLast.entity);
  const loading = useAppSelector(state => state.vehiclePositionLast.loading);
  const updating = useAppSelector(state => state.vehiclePositionLast.updating);
  const updateSuccess = useAppSelector(state => state.vehiclePositionLast.updateSuccess);

  const handleClose = () => {
    props.history.push('/vehicle-position-last' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getTruckImplements({}));
    dispatch(getCompanies({}));
    dispatch(getUsers({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.created = convertDateTimeToServer(values.created);

    const entity = {
      ...vehiclePositionLastEntity,
      ...values,
      truckImplement: truckImplements.find(it => it.id.toString() === values.truckImplementId.toString()),
      company: companies.find(it => it.id.toString() === values.companyId.toString()),
      user: users.find(it => it.id.toString() === values.userId.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          created: displayDefaultDateTime(),
        }
      : {
          ...vehiclePositionLastEntity,
          created: convertDateTimeFromServer(vehiclePositionLastEntity.created),
          truckImplementId: vehiclePositionLastEntity?.truckImplement?.id,
          companyId: vehiclePositionLastEntity?.company?.id,
          userId: vehiclePositionLastEntity?.user?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.vehiclePositionLast.home.createOrEditLabel" data-cy="VehiclePositionLastCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.vehiclePositionLast.home.createOrEditLabel">Create or edit a VehiclePositionLast</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField name="id" required readOnly id="vehicle-position-last-id" label={translate('global.field.id')} validate={{ required: true }} />
              ) : null}
              <ValidatedField
                label={translate('fleetSenseApp.vehiclePositionLast.created')}
                id="vehicle-position-last-created"
                name="created"
                data-cy="created"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('fleetSenseApp.vehiclePositionLast.latitude')}
                id="vehicle-position-last-latitude"
                name="latitude"
                data-cy="latitude"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.vehiclePositionLast.longitude')}
                id="vehicle-position-last-longitude"
                name="longitude"
                data-cy="longitude"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.vehiclePositionLast.odometer')}
                id="vehicle-position-last-odometer"
                name="odometer"
                data-cy="odometer"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.vehiclePositionLast.speed')}
                id="vehicle-position-last-speed"
                name="speed"
                data-cy="speed"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.vehiclePositionLast.vBat')}
                id="vehicle-position-last-vBat"
                name="vBat"
                data-cy="vBat"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.vehiclePositionLast.vSupply')}
                id="vehicle-position-last-vSupply"
                name="vSupply"
                data-cy="vSupply"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.vehiclePositionLast.supplyOn')}
                id="vehicle-position-last-supplyOn"
                name="supplyOn"
                data-cy="supplyOn"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.vehiclePositionLast.activated')}
                id="vehicle-position-last-activated"
                name="activated"
                data-cy="activated"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('fleetSenseApp.vehiclePositionLast.gpsFix')}
                id="vehicle-position-last-gpsFix"
                name="gpsFix"
                data-cy="gpsFix"
                check
                type="checkbox"
              />
              <ValidatedField
                id="vehicle-position-last-truckImplement"
                name="truckImplementId"
                data-cy="truckImplement"
                label={translate('fleetSenseApp.vehiclePositionLast.truckImplement')}
                type="select"
              >
                <option value="" key="0" />
                {truckImplements
                  ? truckImplements.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.licensePlate}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="vehicle-position-last-company"
                name="companyId"
                data-cy="company"
                label={translate('fleetSenseApp.vehiclePositionLast.company')}
                type="select"
              >
                <option value="" key="0" />
                {companies
                  ? companies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="vehicle-position-last-user"
                name="userId"
                data-cy="user"
                label={translate('fleetSenseApp.vehiclePositionLast.user')}
                type="select"
              >
                <option value="" key="0" />
                {users
                  ? users.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.login}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/vehicle-position-last" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default VehiclePositionLastUpdate;
